export const interessadoParse = (value) => {
  if (value) {
    var result = ''
    var list = value.valor
    const attr = value.atributo.substring(1, value.atributo.length - 1)
    for (var i = 0; i < list.length; i++) {
      result = result + list[i][attr] + (i !== list.length - 1 ? ', ' : '')
    }

    return {
      value: result,
      title: result.replace(/, /g, ',\n'),
      class: 'ellipsisContent'
    }
  } else {
    return ''
  }
}
